import { useEffect, useState } from 'react';
import { useScrollPosition } from '../hooks/useScrollPosition.js';
import './Badge.css';
const Badge = ({ badge }) => {

  //const [activePage, setActivePage] = useState(1);

  return (
    <div className="badge">
        {badge}
    </div>
  );

};
export default Badge;